var React = require('react');

function YellowBall (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"13","cy":"13","r":"13","fill":"#FFE01A","key":0}),React.createElement("path",{"d":"M21.5 22.8364C19.2209 24.8076 16.2497 26 13 26C5.8203 26 0 20.1797 0 13C0 9.50698 1.37761 6.33576 3.61914 3.99997C0.347871 16 13 22.8364 21.5 22.8364Z","fill":"#FFAE16","key":1})]);
}

YellowBall.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = YellowBall;

YellowBall.default = YellowBall;
